import React from "react";
import SidePanel from "components/SidePanel/SidePanel";

export default function UpdatePanel(props) {
    return (
        <SidePanel open={props.open} onClose={props.onClose} title="Updates">
            <iframe
                title="Changelog"
                src="https://docs.getsnworks.com/changelog.html"
                className="h-full w-full"
            />
        </SidePanel>
    );
}
